import { render, staticRenderFns } from "./DropdownV2.vue?vue&type=template&id=d67f90f8&"
import script from "./DropdownV2.vue?vue&type=script&lang=js&"
export * from "./DropdownV2.vue?vue&type=script&lang=js&"
import style0 from "./DropdownV2.vue?vue&type=style&index=0&id=d67f90f8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../Breeze.Frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports